
import React from 'react';
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface NumericInputWithPresetsProps {
  value: number | undefined;
  onChange: (value: number) => void;
  presets: { value: number; label: string }[];
  placeholder?: string;
  className?: string;
}

export const NumericInputWithPresets = ({
  value,
  onChange,
  presets,
  placeholder,
  className = ""
}: NumericInputWithPresetsProps) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const numValue = parseInt(e.target.value);
    if (!isNaN(numValue) && numValue > 0) {
      onChange(numValue);
    }
  };

  return (
    <div className={`flex ${className}`}>
      <Input
        type="number"
        value={value || ''}
        onChange={handleInputChange}
        placeholder={placeholder}
        className="rounded-r-none border-r-0 bg-card"
        min="1"
      />
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="outline"
            className="rounded-l-none border-l-0 px-3 bg-card"
            type="button"
          >
            <ChevronDown className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="bg-card">
          {presets.map((preset) => (
            <DropdownMenuItem
              key={preset.value}
              onClick={() => onChange(preset.value)}
            >
              {preset.label}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
